import React, { useEffect, useState } from "react";
import { JsonForms } from "@jsonforms/react";
import {
  materialRenderers,
  materialCells,
} from "@jsonforms/material-renderers";
import ApiService from "../../_services/ApiService";
import { useParams } from "react-router-dom";
import { ILoader } from "../../_components/iloader/iloader";

import "./form-builder.styles.css";

function FormBuilder() {
  const [data, setData] = useState({});
  const [renderingData, setRenderingData] = useState({});
  const [showLoading, setShowLoading] = useState(true);
  const { formId } = useParams();
  const uiSchema = {
    "type": "VerticalLayout",
    "elements": [
      {"type": "HorizontalLayout",
      "elements": [
      { "type": "Control", "scope": "#/properties/applicationType", "options": { "format": "radio" } },
      ]},
      {
        "type": "HorizontalLayout",
        "elements": [
      { "type": "Control", "scope": "#/properties/finNo.ofApplicant" ,"classNames": "custom-control-1" },
      { "type": "Control", "scope": "#/properties/If transfer,PleaseStatePreviousInstitution","classNames": "custom-control-1" },
        ]},
        {"type": "HorizontalLayout",
        "elements": [
      { "type": "Control", "scope": "#/properties/Recruitment Agent Company Name (Please type NA if not applicable)" },
      { "type": "Control", "scope": "#/properties/PSB Academy Country Manager or Staff Name (Please type NA if not applicable)", 
         "options": {
            "multi": true
          } }
        ]},
      { "type": "Control", "scope": "#/properties/Discipline Applying for", "options": { "format": "radio" } },
      {"type": "HorizontalLayout",
        "elements": [
      { "type": "Control", "scope": "#/properties/Programme Applying For (SBM)" },
      { "type": "Control", "scope": "#/properties/Programme Applying For (SET)" },
        ]},
        {"type": "HorizontalLayout",
        "elements": [
        { "type": "Control", "scope": "#/properties/Programme Applying For (SHL)" },
        { "type": "Control", "scope": "#/properties/Programme Applying For (SPS)" }
      ]},
      {"type": "HorizontalLayout",
          "elements": [
      { "type": "Control", "scope": "#/properties/Programme Applying For (SFS)" },
      { "type": "Control", "scope": "#/properties/Interested to progress to a 2nd Programme? Please fill in the course name" }
          ]},
      {"type": "HorizontalLayout",
      "elements": [
      { "type": "Control", "scope": "#/properties/Interested to progress to a 3rd Programme? Please fill in the course name" },
      { "type": "Control", "scope": "#/properties/Name of Applicant" }
      ]},
      {"type": "HorizontalLayout",
      "elements": [
      { "type": "Control", "scope": "#/properties/Passport No" },
      { "type": "Control", "scope": "#/properties/Passport Expiry Date" }
      ]},
      { "type": "Control", "scope": "#/properties/Gender", "options": { "format": "radio" } },
      {
        "type": "HorizontalLayout",
        "elements": [
      { "type": "Control", "scope": "#/properties/Date of Birth" },
      { "type": "Control", "scope": "#/properties/Country of Birth" }
        ]},
        {
          "type": "HorizontalLayout",
          "elements": [
      { "type": "Control", "scope": "#/properties/Nationality" },
      { "type": "Control", "scope": "#/properties/If Others Nationality chosen, please enter your nationality here" }
          ]},
      {
        "type": "HorizontalLayout",
        "elements": [
          { "type": "Control", "scope": "#/properties/addressId" },
          { "type": "Control", "scope": "#/properties/street" }
        ]
      },
      {
        "type": "HorizontalLayout",
        "elements": [
          { "type": "Control", "scope": "#/properties/city" },
          { "type": "Control", "scope": "#/properties/zipCode" }
        ]
      },
      {
        "type": "HorizontalLayout",
        "elements": [
      { "type": "Control", "scope": "#/properties/Email Address" },
      { "type": "Control", "scope": "#/properties/We Chat ID" }
        ]}
    ]
  };

  const schema = {
    "type": "object",
    "properties": {
      "city": { "type": "string" },
      "Gender": { "enum": ["Male", "Female"], "type": "string" },
      "Intake": { "enum": ["2023MAR", "2023APR", "2023MAY"], "type": "string" },
      "street": { "type": "string" },
      "zipCode": { "type": "string" },
      "addressId": { "enum": ["Home Country Address"], "type": "string", "label": "Address Type" },
      "We Chat ID": { "type": "string" },
      "Nationality": { "enum": ["DE", "IT", "JP", "US", "RU", "Other"], "type": "string" },
      "Passport No": { "type": "integer" },
      "Date of Birth": { "type": "string", "format": "date", "description": "schema-based date picker" },
      "Email Address": { "type": "string" },
      "applicationType": { "enum": ["New", "Transfer"], "type": "string" },
      "Country of Birth": { "enum": ["A", "B", "C"], "type": "string" },
      "Name of Applicant": { "type": "string" },
      "finNo.ofApplicant": { "type": "string" },
      "Passport Expiry Date": { "type": "string", "format": "date", "description": "schema-based date picker" },
      "Discipline Applying for": {
        "enum": [
          "Accounting Banking Business Analytics Finance Graphic Design and Media HumanResource Management Marketing Media and Communication Supply Chain Management and Tourism and Hospitality Management",
          "Mechanical and Electrical Engineering, Information Technology and Cybersecurity, Environmental andOccupational Health and Safety",
          "Biomedical, Pharmaceutical and Molecular Science, Sport and Exercise Sciences, Life Sciences",
          "Leadership in Business Management at Master’s Level",
          "English proficiency programmes, IGCSE preparatory programmes"
        ],
        "type": "string"
      },
      "Programme Applying For (SBM)": { "enum": ["A", "B", "C"], "type": "string" },
      "Programme Applying For (SET)": { "enum": ["A", "B", "C"], "type": "string" },
      "Programme Applying For (SFS)": { "enum": ["A", "B", "C"], "type": "string" },
      "Programme Applying For (SHL)": { "enum": ["A", "B", "C"], "type": "string" },
      "Programme Applying For (SPS)": { "enum": ["A", "B", "C"], "type": "string" },
      "If transfer,PleaseStatePreviousInstitution": { "type": "string" },
      "If Others Nationality chosen, please enter your nationality here": { "type": "string" },
      "Recruitment Agent Company Name (Please type NA if not applicable)": { "type": "string" },
      "Interested to progress to a 2nd Programme? Please fill in the course name": { "type": "string" },
      "Interested to progress to a 3rd Programme? Please fill in the course name": { "type": "string" },
      "PSB Academy Country Manager or Staff Name (Please type NA if not applicable)": { "type": "string" }
    }
  };

  const handleSubmit = async()=>{
    try{
      const res = await ApiService.submitApplicationForm(data);
      console.log(res);
      setData({})
    }catch(err){
      console.log(err);
    }
  };

  useEffect(() => {
    const fetchFormData = async () => {
      console.log(ApiService);
      const formDataRes = await ApiService.fetchFormData(formId);
      let formData = formDataRes.data.data;

      if (typeof formData === "string") formData = JSON.parse(formData);
      if (typeof formData.schemaJson === "string")
        formData.schemaJson = JSON.parse(formData.schemaJson);
      if (typeof formData.uiSchemaJson === "string")
        formData.uiSchemaJson = JSON.parse(formData.uiSchemaJson);
      setRenderingData(formData);
      setShowLoading(false);
    };

    fetchFormData();
  }, []);

  const submitData = ()=>{
    setData({});
  }

  return showLoading ? (
    <ILoader isShow={showLoading} loadingText={"Please wait..."} />
  ) : (
    <div className="form-container">
      <div className="form-wrapper">
      <div className="header">
        <div dangerouslySetInnerHTML={{ __html: renderingData?.headerHtml }} />
      </div>
        <JsonForms
          schema={schema}
          uischema={uiSchema}
          data={data}
          renderers={materialRenderers}
          cells={materialCells}
          onChange={({ data, errors }) =>{console.log(data); return setData(data)}}
        />
        <button
          className="btn btn-primary btn-block form-button"
          onClick={handleSubmit}
        >
          Submit
        </button>
        <div dangerouslySetInnerHTML={{ __html: renderingData?.footerHtml }} />
      </div>
    </div>
  );
}

export default FormBuilder;
